import React from "react";
import { Accordion, AccordionDetails } from "@mui/material";
import { Container, Row, Col } from "react-bootstrap";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import InputWrapper from "../../citizen/AVPForms/layout/inputWrapper";
import ButtonWrapper from "../../citizen/AVPForms/components/Button";
import { CustomAccordionSummary } from "../../citizen/AVPForms/components/StyledComponent";

const EmpFileTransfer = ({
  t,
  control,
  handleSubmit,
  onSubmit,
  watch,
  departmentList,
  getOfficesListForIndex,
  getApplicationFlowForIndex,
  handleEmpSearch,
  handleFileTransfer,
  employeeIdList,
}) => {
  const watchDepartment = watch("selectedDepartmentFrom");
  const watchAuthority = watch("selectedAuthorityFrom");

  return (
    <section className="groupContainer3">
      <form className="formContainer" onSubmit={handleSubmit(onSubmit)}>
        <Accordion defaultExpanded>
          <CustomAccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Employee File Transfer")}</h2>
            </div>
          </CustomAccordionSummary>

          <AccordionDetails className="formInputContainer common-app-form emp-transfer-accordiondetails">
            <div className="emp-transfer-container">
              {/* FROM Section */}
              <div className="emp-transfer-formcontainer">
                <div className="formHeaderContainer">
                  <h2 className="formHeading">{t("Transfer Files From")}</h2>
                </div>

                <Container className="formInputContainer common-app-form emp-transfer" fluid>
                  <Row>
                    <Col md={6}>
                      <InputWrapper
                        control={control}
                        label="Department"
                        name={`selectedDepartmentFrom`}
                        type="selectInput"
                        data={departmentList}
                        mandatory
                        width={"16.25vw"}
                        validation={{
                          required: { value: true, message: "This field is required" },
                        }}
                      />
                    </Col>

                    <Col md={6}>
                      <InputWrapper
                        control={control}
                        label="Authority"
                        name={`selectedAuthorityFrom`}
                        type="selectInput"
                        data={getOfficesListForIndex(watch("selectedDepartmentFrom"))}
                        mandatory
                        width={"16.25vw"}
                        validation={{
                          required: { value: true, message: "This field is required" },
                        }}
                        disabled={!getApplicationFlowForIndex()}
                      />
                    </Col>
                  </Row>

                  {employeeIdList?.length > 0 && (
                    <Row>
                      <Col>
                        <InputWrapper
                          width={"96.5%"}
                          control={control}
                          label={"Select Employee Id"}
                          inputLabel="Select Employee Id"
                          placeholder="Select Employee Id"
                          name="employeeIdFrom"
                          type="searchSelect"
                          returnObject={true}
                          data={employeeIdList}
                          mandatory
                          validation={{
                            required: { value: true, message: "This field is required" },
                          }}
                        />
                      </Col>
                    </Row>
                  )}
                </Container>
              </div>

              {/* TO Section */}
              <div className="formContainer emp-transfer-formcontainer">
                <div className="formHeaderContainer">
                  <h2 className="formHeading">{t("Transfer Files To")}</h2>
                </div>

                <Container className="formInputContainer common-app-form emp-transfer" fluid>
                  <Row>
                    <Col md={6}>
                      <InputWrapper
                        control={control}
                        label="Department"
                        name={`selectedDepartmentTo`}
                        type="selectInput"
                        data={departmentList}
                        defaultValue={watchDepartment || ""}
                        disabled
                        mandatory
                        width={"16.25vw"}
                        validation={{
                          required: { value: true, message: "This field is required" },
                        }}
                      />
                    </Col>

                    <Col md={6}>
                      <InputWrapper
                        control={control}
                        label="Authority"
                        name={`selectedAuthorityTo`}
                        type="selectInput"
                        data={getOfficesListForIndex(watch("selectedDepartmentTo"))}
                        defaultValue={watchAuthority || ""}
                        disabled
                        mandatory
                        width={"16.25vw"}
                        validation={{
                          required: { value: true, message: "This field is required" },
                        }}
                      />
                    </Col>
                  </Row>

                  {employeeIdList?.length > 0 && (
                    <Row>
                      <Col>
                        <InputWrapper
                          width={"96.5%"}
                          control={control}
                          label={"Select Employee Id"}
                          inputLabel="Select Employee Id"
                          placeholder="Select Employee Id"
                          name="employeeIdTo"
                          type="searchSelect"
                          returnObject={true}
                          data={employeeIdList}
                          mandatory
                          validation={{
                            required: { value: true, message: "This field is required" },
                          }}
                        />
                      </Col>
                    </Row>
                  )}
                </Container>
              </div>
            </div>

            {/* Buttons */}
            <div className="buttonWrapper emp-transfer-buttonwrapper">
              <ButtonWrapper
                variant="contained"
                color="info"
                size="medium"
                label={
                  <React.Fragment>
                    Search{" "}
                    <SearchIcon
                      sx={{
                        color: "#fff",
                        height: "18px",
                        width: "18px",
                      }}
                    />
                  </React.Fragment>
                }
                type="button"
                disabled={!watch("selectedAuthorityFrom")}
                onClick={() => handleEmpSearch(watch("selectedAuthorityFrom"))}
                sx={{ backgroundColor: "#1565C0", marginRight: "4px", marginTop: "20px" }}
              />

              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label={"Transfer"}
                type="button"
                disabled={!(watch("employeeIdTo") && watch("employeeIdFrom"))}
                onClick={handleFileTransfer}
                sx={{ backgroundColor: "black", marginRight: "4px", marginTop: "20px" }}
              />
            </div>
          </AccordionDetails>
        </Accordion>
      </form>
    </section>
  );
};

export default EmpFileTransfer;
